import * as preact from 'preact'
const { h, Component } = preact
import PureComponent from './preact-pure-component'
import { testReducedMotion } from '@nrk/feature-tests'

interface Props {
  playing: boolean
  className?: string
  sources: {
    mp4: string
  }
  loop?: boolean
  playsInline?: boolean
  muted?: boolean
  size: {
    height: number
    width: number
  }
  poster: string
}

export class HTML5Video extends PureComponent<Props, {}> {
  elm?: HTMLVideoElement
  playPromise?: Promise<any>

  componentDidMount() {
    const { playing } = this.props

    if (this.elm && playing) {
      this.play()
    }
  }

  componentWillUnmount() {
    this.pause()
    this.elm = undefined
    this.playPromise = undefined
  }

  componentDidUpdate(prevProps: Props) {
    if (this.elm) {
      if (!prevProps.playing && this.props.playing) {
        this.play()
      } else if (prevProps.playing && !this.props.playing) {
        // this.pause()
      }
    }
  }

  play = () => {
    if (this.elm && !testReducedMotion()) {
      const playPromise = this.elm.play()
      if (playPromise) {
        this.playPromise = playPromise.then(() => {}).catch(error => {})
      }
    }
  }

  pause = () => {
    if (this.elm) {
      if (this.playPromise) {
        this.playPromise.then(() => {
          this.elm && this.elm.pause()
        })
      } else {
        this.elm.pause()
      }
    }
  }

  render() {
    const { sources, size, className, poster } = this.props
    const { height, width } = size
    return (
      <video
        className={className}
        loop
        playsInline
        muted
        height={height}
        width={width}
        x-webkit-airplay="deny"
        ref={elm => (this.elm = elm)}
        src={sources.mp4}
        type="video/mp4"
        poster={poster}
      >
        Nettleseren din støtter ikke video.
      </video>
    )
  }
}
